import { render } from "./SyncTRTModal.vue?vue&type=template&id=1d98fd26&scoped=true"
import script from "./SyncTRTModal.vue?vue&type=script&lang=js"
export * from "./SyncTRTModal.vue?vue&type=script&lang=js"

import "./SyncTRTModal.vue?vue&type=style&index=0&id=1d98fd26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d98fd26"]])

export default __exports__